import { NEED_DOMAIN_STEPS } from '../../utilities/constants';
import actions from './menuActionTypes';

const initialState = { navMenu: NEED_DOMAIN_STEPS };

export default (state = initialState, action = null) => {
    if (action.type === actions.SET_NAV_MENU) {
        return { ...state, navMenu: action.payload };
    } else {
        return state;
    }
};
